import { render, staticRenderFns } from "./ResearchProjects.vue?vue&type=template&id=858451a8&scoped=true"
import script from "./ResearchProjects.vue?vue&type=script&lang=js"
export * from "./ResearchProjects.vue?vue&type=script&lang=js"
import style0 from "./ResearchProjects.vue?vue&type=style&index=0&id=858451a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858451a8",
  null
  
)

export default component.exports